import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { Button } from "react-aria-components";


export default function SidePanelUpliftsView({ data, onViewPage }: any) {
    const navigate = useNavigate()
    function viewEntity() {
        // Navigation.view.navigate(navigate, EntityNames.uplifts, data.id, data)
    }
    return (<>
        {data &&
            <>
                {<SidePanelHeader descriptor="Uplift" value={`${data.reference}`} statuses={[data.status]} onClick={!onViewPage ? () => viewEntity() : undefined} />}
                <Actions data={data} />
                <SidePanelInfo
                    values={[
                        { label: "Requested by", value: data.requestedBy },
                        { label: "Reference", value: data.reference },
                        { label: "Request Type", value: data.requestType },
                        { label: "Account", value: data.accountName },
                    ]}
                />
            </>
        }
    </>)
}

function Actions({ data }: { data: any }) {

    return (
        <div className="display--flex gap--s flex__wrap--wrap margin__top--s">
            {/* {data.status.value === UpliftStatusSmartEnum.InProgress.value && <EditButton id={data.id}/>} */}
        </div>
    )
}

function EditButton({ id }: { id: string }) {
    const navigate = useNavigate()

    return (
        <Button className={"button button--small button--primary button--with-icon"} onPress={() => { Navigation.CreateUplifts.navigate(navigate, id) }}>
            <p className="button-text">Edit Uplift</p>
        </Button>
    )
}